// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableSwitch_container__uq0vz"};